// extracted by mini-css-extract-plugin
module.exports = {"headerMobile":"mobile_headerMobile__w4N4X","btn":"mobile_btn__P8UK4","text":"mobile_text__A246z"};